import { render, staticRenderFns } from "./NumberingSettings3.vue?vue&type=template&id=53d4a16a&"
import script from "./NumberingSettings3.vue?vue&type=script&lang=js&"
export * from "./NumberingSettings3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports